import $ from './app/jquery-shim.js';
import Utils from './app/utils.js';
import Accordion from './app/accordion.js';
import Anchor from './app/anchor.js';
import FixedHeader from './app/fixedheader.js';
import HeightLine from './app/heightline.js';
import ResponsiveTable from './app/responsive-table.js';
import Slidebar from './app/slidebar.js';
import Tab from './app/tab.js';
import CurrentNav from './app/current-nav.js';
import buildFormat from './app/format.js';
import OwlCarousel from 'owl.carousel';
import SlickCss from 'slick-carousel/slick/slick.scss';
import SlickhemeCss from 'slick-carousel/slick/slick-theme.scss';
import Slick from 'slick-carousel';
import ScrollReveal from "scrollreveal";
import particleJS from 'particles.js';

import fontAwesome from "font-awesome/scss/font-awesome.scss"
import OwlCss from "owl.carousel/dist/assets/owl.carousel.css"
import OwlThemeCss from "owl.carousel/dist/assets/owl.theme.default.css"

class App {
  constructor() {
    this.Utils = new Utils();
    this.Accordion = new Accordion();
    this.Anchor = new Anchor();
    this.FixedHeader = new FixedHeader();
    this.HeightLine = new HeightLine();
    this.ResponsiveTable = new ResponsiveTable();
    this.Slidebar = new Slidebar();
    this.CurrentNav = new CurrentNav();
    this.Tab = new Tab();

    //SPメニューの高さ取得
    function menuHight() {
      var win = $(window).innerWidth();
      if (win > 750) {
        return false;
      }

      var $smpHeaderHeight = $('.l-header').height();
      var windowHeight = window.innerHeight;
      var winH = windowHeight - $smpHeaderHeight;

      console.log($smpHeaderHeight);

      //動かすターゲットを取得
      var targetSlidebarWrap = $('.c-slidebar-menu'),
        targetSlidebarMenu = $('.c-slidebar__parent'),
        targetSlidebarBtn = $('.c-slidebar-menu__parent');


      //いざ実行(クリックしたら処理を実行する)
      targetSlidebarBtn.on('click', function () {
        $('.c-slidebar-menu').toggleClass('is-active');

      });
    }

    //フッターメニューSPスライド
    function menuSlide() {
      var win = $(window).innerWidth();
      if (win > 750) {
        return false;
      }
      $('.l-footer__block').on('click', function () {
        $(this).children(".l-footer__menutitle").toggleClass('is-open');
        $(this).children(".l-footer__menulist.is-sub").slideToggle();
      })
    }

    //owlcarousel
    function owlCarousel() {
      var owls = $('.owl-carousel');
      if (owls.length === 0) {
        return false
      }
      //->スライダー
      owls.imagesLoaded(function () {
        $('.c-main-visual__slider').owlCarousel({
          items: 1,
          margin: 0,
          dots: true,
          loop: true,
          nav: false,
          autoplayHoverPause: true,
          autoplay: true,
          autoplaySpeed: 500,
          autoWidth: false,
          autoHeight: false,
          center: true,
          navText: ['<img src="../assets/images/icon-slider-prev.svg" />', '<img src="../assets/images/icon-slider-next.svg" />'],
        });
      });
      //->カルーセル
      owls.imagesLoaded(function () {
        $('.c-main-visual__carousel').owlCarousel({
          items: 1,
          margin: 16,
          dots: true,
          loop: true,
          nav: true,
          autoplayHoverPause: true,
          autoplay: false,
          autoplaySpeed: 500,
          autoWidth: false,
          autoHeight: false,
          center: true,
          navText: ['<div class="c-main-visual__nav is-left"><i class="fa fa-angle-left" aria-hidden="true"></i></div>', '<div class="c-main-visual__nav is-right"><i class="fa fa-angle-right" aria-hidden="true"></i></div>'],
          responsive: {
            // breakpoint from 0 up
            0: {
              stagePadding: 32,
            },
            // breakpoint from 750  up
            750: {
              stagePadding: 64,
            },
            // breakpoint from 950 up
            950: {
              stagePadding: 156,
            },
            1400: {
              stagePadding: 312,
            }
          }
        });
      });
      //->カルーセル_ノーマル
      owls.imagesLoaded(function () {
        $('.c-main-visual__carousel.is-normal').owlCarousel({
          items: 1,
          margin: 8,
          dots: true,
          loop: true,
          nav: true,
          autoplayHoverPause: true,
          autoplay: false,
          autoplaySpeed: 500,
          autoWidth: false,
          autoHeight: false,
          center: true,
          navText: ['<div class="c-main-visual__nav is-left"><i class="fa fa-angle-left" aria-hidden="true"></i></div>', '<div class="c-main-visual__nav is-right"><i class="fa fa-angle-right" aria-hidden="true"></i></div>'],
          responsive: {
            // breakpoint from 0 up
            0: {
              stagePadding: 32,
            },
            // breakpoint from 750  up
            750: {
              stagePadding: 64,
            },
            // breakpoint from 950 up
            950: {
              stagePadding: 156,
            },
            1400: {
              stagePadding: 312,
            }
          }
        });
      });
      //->カルーセル_レイヤー
      owls.imagesLoaded(function () {
        $('.c-main-visual-layer__carousel').owlCarousel({
          items: 1,
          margin: 0,
          dots: true,
          loop: true,
          nav: false,
          autoplayHoverPause: true,
          autoplay: true,
          autoplaySpeed: 500,
          autoWidth: false,
          autoHeight: false,
          center: true,
          navText: ['<img src="..//assets/images/icon-slider-prev.svg" />', '<img src="../assets/images/icon-slider-next.svg" />'],
        });
      });
      //->カード_カルーセル
      owls.imagesLoaded(function () {
        $('.js-card-slider').owlCarousel({
          margin: 0,
          dots: false,
          loop: true,
          nav: true,
          autoplayHoverPause: true,
          autoplay: true,
          autoplaySpeed: 500,
          autoWidth: false,
          autoHeight: false,
          center: true,
          navText: ['<img src="../assets/images/icon-slider-prev.svg" />', '<img src="../assets/images/icon-slider-next.svg" />'],
          responsive: {
            // breakpoint from 0 up
            0: {
              items: 1,
            },
            // breakpoint from 750 up
            750: {
              items: 3,
            }
          }
        });
      });
    }

    var sliders = {
      slick: function () {
        $('.js-contents-slider').slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          dots: true,
        });

        $('.c-service-top__buttons li a').on('click', function () {
          var index = $(this).data('slide-target');
          $('.js-contents-slider').slick('slickGoTo', index);
        });
        $('.js-slider-button .c-contents-slide__arrow').on('click', function () {
          var index = $(this).data('slide-target');
          if (index === 'next') {
            $('.js-contents-slider').slick('slickNext');
          } else if (index === 'prev') {
            $('.js-contents-slider').slick('slickPrev');
          }
        });
      },
    };

    var animation = {
      reveal: function () {
        window.sr = ScrollReveal({duration: 600});

        function domEach(items, callback) {
          if (typeof items === "string") {
            var items = $(items);
          }
          for (var i = 0; i < items.length; i++) {
            var item = items[i];
            // callback = callback.bind(item)
            callback(i, item);
          }
        }


        // sr.reveal(".top .c-heading.is-xlg span", {scale: 1,viewFactor: 0.5, duration: 1000,origin:'bottom',distance: '50px', easing: 'cubic-bezier(0.165, 0.84, 0.44, 1)'}, 100);
        // sr.reveal(".top .c-heading.is-xlg small", {scale: 1,viewFactor: 0.5, duration: 1000, delay:200, origin:'bottom',distance: '50px', easing: 'cubic-bezier(0.165, 0.84, 0.44, 1)'}, 100);
        sr.reveal(".c-opening__title", {
          scale: 1,
          viewFactor: 0.5,
          duration: 1000,
          origin: 'bottom',
          distance: '50px',
          easing: 'cubic-bezier(0.165, 0.84, 0.44, 1)'
        }, 100);
        sr.reveal(".c-opening__text", {
          scale: 1,
          viewFactor: 0.8,
          duration: 1000,
          origin: 'bottom',
          distance: '50px',
          easing: 'cubic-bezier(0.165, 0.84, 0.44, 1)'
        }, 100);
        sr.reveal(".l-page-header__subtext", {
          scale: 1,
          viewFactor: 0.8,
          duration: 1000,
          origin: 'bottom',
          distance: '50px',
          easing: 'cubic-bezier(0.165, 0.84, 0.44, 1)'
        }, 100);
        sr.reveal(".l-page-header__title", {
          scale: 1,
          viewFactor: 0.8,
          duration: 1000,
          delay: 100,
          origin: 'bottom',
          distance: '50px',
          easing: 'cubic-bezier(0.165, 0.84, 0.44, 1)'
        }, 100);
        sr.reveal(".c-achievements-block__title", {
          scale: 1,
          viewFactor: 0.8,
          duration: 1000,
          delay: 100,
          origin: 'bottom',
          distance: '50px',
          easing: 'cubic-bezier(0.165, 0.84, 0.44, 1)'
        }, 100);
        sr.reveal(".l-page-header__subtitle", {
          scale: 1,
          viewFactor: 0.8,
          duration: 1000,
          delay: 200,
          origin: 'bottom',
          distance: '50px',
          easing: 'cubic-bezier(0.165, 0.84, 0.44, 1)'
        }, 100);
        sr.reveal(".c-achievements-block__subtitle", {
          scale: 1,
          viewFactor: 0.8,
          duration: 1000,
          delay: 200,
          origin: 'bottom',
          distance: '50px',
          easing: 'cubic-bezier(0.165, 0.84, 0.44, 1)'
        }, 100);
        sr.reveal(".c-decoration__deco.is-sr.is-left", {
          scale: 1,
          viewFactor: 0.8,
          duration: 1000,
          origin: 'top',
          distance: '50px',
          easing: 'cubic-bezier(0.165, 0.84, 0.44, 1)'
        }, 100);
        sr.reveal(".c-decoration__deco.is-sr.is-right", {
          scale: 1,
          viewFactor: 0.8,
          duration: 1000,
          origin: 'bottom',
          distance: '50px',
          easing: 'cubic-bezier(0.165, 0.84, 0.44, 1)'
        }, 100);
        sr.reveal(".c-message-top__inner", {
          scale: 1,
          viewFactor: 0.2,
          duration: 1000,
          origin: 'bottom',
          distance: '20px',
          easing: 'cubic-bezier(0.165, 0.84, 0.44, 1)'
        }, 100);
        sr.reveal(".c-recruit-block__image-text", {
          scale: 1,
          viewFactor: 1,
          duration: 1000,
          origin: 'bottom',
          distance: '50px',
          easing: 'cubic-bezier(0.165, 0.84, 0.44, 1)'
        }, 100);
        sr.reveal(".c-service-block__image", {
          scale: 1,
          viewFactor: 0.5,
          duration: 1000,
          origin: 'bottom',
          distance: '50px',
          easing: 'cubic-bezier(0.165, 0.84, 0.44, 1)'
        }, 100);
        sr.reveal(".c-mission-top__icon", {
          scale: 2,
          opacity: 0,
          viewFactor: 1,
          duration: 1200,
          easing: 'cubic-bezier(0.165, 0.84, 0.44, 1)'
        }, 100);

        var blocks01 = $(".c-top-benefits__block");
        domEach(blocks01, function (key, item) {
          sr.reveal(item, {
            scale: 1,
            duration: 600,
            delay: 0,
            origin: 'bottom',
            distance: '20px',
            easing: 'cubic-bezier(0.165, 0.84, 0.44, 1)'
          }, 100);
          sr.reveal(item.children[1], {
            delay: 100,
            scale: 1,
            origin: 'bottom',
            distance: '20px',
            easing: 'cubic-bezier(0.165, 0.84, 0.44, 1)'
          }, 100);
          sr.reveal(item.children[2], {
            delay: 200,
            scale: 1,
            origin: 'bottom',
            distance: '20px',
            easing: 'cubic-bezier(0.165, 0.84, 0.44, 1)'
          }, 100);
          sr.reveal(item.children[3], {
            delay: 100,
            scale: 1,
            origin: 'bottom',
            distance: '20px',
            easing: 'cubic-bezier(0.165, 0.84, 0.44, 1)'
          }, 100);
          sr.reveal(item.children[4], {
            delay: 400,
            scale: 1,
            origin: 'bottom',
            distance: '20px',
            easing: 'cubic-bezier(0.165, 0.84, 0.44, 1)'
          }, 100);
          sr.reveal(item.children[5], {
            delay: 500,
            scale: 1,
            origin: 'bottom',
            distance: '20px',
            easing: 'cubic-bezier(0.165, 0.84, 0.44, 1)'
          }, 100);
          sr.reveal(item.children[6], {
            delay: 600,
            scale: 1,
            origin: 'bottom',
            distance: '20px',
            easing: 'cubic-bezier(0.165, 0.84, 0.44, 1)'
          }, 100);
          sr.reveal(item.children[7], {
            delay: 700,
            scale: 1,
            origin: 'bottom',
            distance: '20px',
            easing: 'cubic-bezier(0.165, 0.84, 0.44, 1)'
          }, 100);
          sr.reveal(item.children[8], {
            delay: 800,
            scale: 1,
            origin: 'bottom',
            distance: '20px',
            easing: 'cubic-bezier(0.165, 0.84, 0.44, 1)'
          }, 100);
          sr.reveal(item.children[9], {
            delay: 900,
            scale: 1,
            origin: 'bottom',
            distance: '20px',
            easing: 'cubic-bezier(0.165, 0.84, 0.44, 1)'
          }, 100);
          sr.reveal(item.children[10], {
            delay: 1000,
            scale: 1,
            origin: 'bottom',
            distance: '20px',
            easing: 'cubic-bezier(0.165, 0.84, 0.44, 1)'
          }, 100);
        });

        // TOP - 最初のアニメーション
        function myCallback(el) {
          el.classList.add('is-animating');
        }

        // TOP - 文字が出てくるところ
        function afterCallback(el) {
          $('.c-main-visual__overlay').on('transitionend webkitTransitionEnd', function () {
            el.classList.add('is-visible');
          });
        }


        ScrollReveal().reveal('.c-development__image-wrap', {beforeReveal: myCallback});
        ScrollReveal().reveal('.l-section.is-text', {beforeReveal: myCallback});

        // 画像が読み込めたらアニメーションを始める
        $('.c-main-visual').imagesLoaded(function () {
          ScrollReveal().reveal('.c-main-visual', {beforeReveal: myCallback});
          ScrollReveal().reveal('.c-main-visual', {afterReveal: afterCallback});
        });
      },

      // 社長のガタガタの部分
      painting: function () {
        var $image = $('.c-message-block__image-wrap');
        var movie = document.querySelector('#video');
        if ($image.length == 0) {
          return false;
        }
        var start_scroll_pos_video = $(movie).offset().top;
        var start_scroll_pos = $image.offset().top;
        var ua = navigator.userAgent;


        // スマホ・タブレットは動画の再生を開始するスクロール位置をオフセットする
        if (ua.indexOf('iPhone') > 0 || ua.indexOf('Android') > 0 && ua.indexOf('Mobile') > 0) {
          start_scroll_pos = start_scroll_pos - window.innerHeight + Math.floor(window.innerHeight / 10); // 画面下部に画像が来たら // + Math.floor(window.innerHeight / 6); // 画面下部から6分の1ぐらいに画像が来たら
          start_scroll_pos_video = start_scroll_pos_video - window.innerHeight + Math.floor(window.innerHeight / 10); // 画面下部に画像が来たら // + Math.floor(window.innerHeight / 6); // 画面下部から6分の1ぐらいに画像が来たら
        } else if (ua.indexOf('iPad') > 0 || ua.indexOf('Android') > 0) {
          start_scroll_pos = start_scroll_pos - window.innerHeight + Math.floor(window.innerHeight / 3); // 画面下部から3分の1ぐらいに画像が来たら
          start_scroll_pos_video = start_scroll_pos_video - window.innerHeight + Math.floor(window.innerHeight / 3); // 画面下部から3分の1ぐらいに画像が来たら
        } else {
          start_scroll_pos = start_scroll_pos - window.innerHeight + Math.floor(window.innerHeight / 2); //pc
          start_scroll_pos_video = start_scroll_pos_video - window.innerHeight + Math.floor(window.innerHeight / 2); //pc
        }


        var addClassDone = false;

        $(window).scroll(function () {
          if (start_scroll_pos_video < $(window).scrollTop()) {
            movie.play();
          }
          if (start_scroll_pos < $(window).scrollTop() && addClassDone == false) {
            addClassDone = true;

            $image.addClass('is-animating');
            var interval = setInterval(function () {
              $image.removeClass('is-animating');
              addClassDone = false;
              clearInterval(interval);
            }, 6000);
          }
        });
      },
    };


    // ドットのパーティクル
    function do_particle() {
      if ($('.top-mission-particles').length >= 1) {
        particlesJS.load('particles-js', '/wp-content/themes/polygonmagic/resource/polygonmagic/particlesjs-config-top.json');
      } else if ($('.aboutus-particles').length >= 1) {
        particlesJS.load('particles-js-aboutus', '/wp-content/themes/polygonmagic/resource/polygonmagic/particlesjs-config.json');
      } else {
        return false;
      }
    }


    $(function () {
      $(window).resize();
      ;(function (a) {
        a.fn.rwdImageMaps = function () {
          var c = this;
          var b = function () {
            c.each(function () {
              if (typeof (a(this).attr("usemap")) == "undefined") {
                return
              }
              var e = this, d = a(e);
              a("<img />").on('load', function () {
                var g = "width", m = "height", n = d.attr(g), j = d.attr(m);
                if (!n || !j) {
                  var o = new Image();
                  o.src = d.attr("src");
                  if (!n) {
                    n = o.width;
                  }
                  if (!j) {
                    j = o.height;
                  }
                }
                var f = d.width() / 100, k = d.height() / 100, i = d.attr("usemap").replace("#", ""), l = "coords";
                a('map[name="' + i + '"]').find("area").each(function () {
                  var r = a(this);
                  if (!r.data(l)) {
                    r.data(l, r.attr(l))
                  }
                  var q = r.data(l).split(","), p = new Array(q.length);
                  for (var h = 0; h < p.length; ++h) {
                    if (h % 2 === 0) {
                      p[h] = parseInt(((q[h] / n) * 100) * f);
                    } else {
                      p[h] = parseInt(((q[h] / j) * 100) * k)
                    }
                  }
                  r.attr(l, p.toString())
                })
              }).attr("src", d.attr("src"))
            })
          };
          a(window).resize(b).trigger("resize");
          return this
        }
      })(jQuery);
      menuSlide();
      owlCarousel();
      sliders.slick();
      $('img[usemap]').rwdImageMaps();
      animation.painting();
      do_particle();


      $('.c-post-card.is-normal .c-post-card__block').each(function (index, element) {
        if ($(this).find('.c-post-card__link').length === 0) {
          $(this).find('.c-post-card__content').css('padding-bottom', 0);
        }
      });
      if ($(".c-post-card__text.is-achievements").length > 0) {
        $(".c-post-card__text.is-achievements").each(function (index, element) {
          if ($(this).get(0).scrollHeight <= $(this).innerHeight()) {
            $(this).find('.c-post-card__text-more').hide();
          } else {
            $(this).find('.c-post-card__text-more').click(function () {
              $(this).hide();
              $(this).parent().css("max-height", "none");
            });
          }
        });
      }
    });

    $(window).on('load', function () {
      animation.reveal();
    });
  }
}

window.GApp = new App();
